<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <div class="nav-box justify-align">
      <div class=" nav-box-sec">
        <div class="justify-align" style="width: 100%">
          <div class="nav-item" @click="clickNav(index)" :class="[item.status==statusType?'active':'']" v-for="(item,index) in currNavList" :key="index">{{item.name}}</div>
        </div>
      </div>
      <img @click="clickNavMore" :src="require('../../assets/'+appTheme+'/xia_icon.png')" alt="" />
    </div>
    <div class="nav-show-box" v-if="navShow==1">
      <span @click="clickSecNav(item)" v-for="(item,index) in navList" :key="index" :class="[(is_nav_show==1&&index==0)?'is-hide':'',(is_nav_show==2&&index==1)?'is-hide':'']">{{item.name}}</span>
    </div>
    <van-list v-if="orderList.length"  v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
      <div class="order-list">
        <div class="order-item" v-for="(item,index) in orderList" :key="index">
          <div class="order-top-box justify-align">
            <div class="mch-header left-justifying"><img class="shop-icon" :src="require('../../assets/'+appTheme+'/shop_icon.png')" /> {{item.shop.name}}</div>
            <div class="order-num">订单号：{{item.payment_no}}</div>
          </div>
          <div class="order-content">
            <div class="goods-item left-justifying" v-for="(goods,i) in item.order_goods" :key="i">
              <img class="goods-pic" @click="goDes(item.id)" :src="goods.full_image" />
              <div class="goods-content">
                <div class="goods-name" @click="goDes(item.id)">
                  <!--              <span>￥1</span>-->
                  {{goods.name}}</div>
                <!--            <div class="tag-box">-->
                <!--              <span class="tag">配送：快递</span><span class="tag">状态：客户取消</span>-->
                <!--            </div>-->
                <div class="justify-align" style="margin-top: 2.66667vw;">
                  <div @click="goDes(item.id)">
                    <span class="flex-grow-0 price">￥{{goods.price}}</span>
                    <span class="num" style="font-size: 3.2vw;display: inline-block;margin-left:1.33333vw;">×{{goods.number}}</span>
                  </div>
                  <!--                <div v-if="(statusType=='-1' && item.status==3) || statusType == 3" class="btn-comment" @click="goOrderComment(item)">评价</div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="order-btn-box">
            <div class="order-sum">
              <!--          <span class="sum-goods">共计1件商品  </span>-->
              <span class="sum-goods-txt">消费总额</span>
              <span class="price-num">￥{{item.payment_price}}</span>
            </div>
            <div class="btn-list">
              <div class="btn btn-des" @click="goDes(item.id)">详情</div>
              <div class="btn btn-des" v-if="(statusType=='-1' && item.status==0) || statusType== 0" @click="cancelOrder(item.id)">取消订单</div>
              <div class="btn" v-if="(statusType=='-1' && item.status==0) || statusType== 0" @click="goPay(item)">付款</div>
              <div class="btn" style="margin-right: 2vw" v-if="(statusType=='null' && item.status==2) || statusType == 2" @click="takeGoodClick(item.id)">确认收货</div>
              <div class="btn btn-des" v-if="(statusType=='-1' && item.status==1 && item.refund == null) || (statusType == 2&&item.refund == null ) || (statusType == 1&&item.refund == null )" @click="takeSalesReturn (item.id)">申请退款</div>
              <!--            <div class="btn btn-des" style="color: #eab224" v-if="(statusType=='null' && item.status==2) || (statusType == 2&&item.refund !== null) || (statusType == 1&&item.refund !== null)" @click="clickSalesPop(item)">退款中</div>-->
              <div class="btn" v-if="(statusType=='-1' && item.status==3) || statusType == 3" @click="goOrderComment(item.id)">评价</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div style="text-align: center;margin-top: 20vw;" v-else>暂无数据</div>
    <div style="padding-bottom: 2.66667vw;" class="null-box"></div>
  </div>
</template>


<script>
import { getOrderList,orderDel, takeGood } from '@/api/order'
import {Dialog} from "vant";
export default {
  name: "index",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      returnShow:false,
      refundItem:'',
      // null全部 0待支付 1已支付 2已发货 3已收货 10已评价(已完成)
      navList: [{name: '已收货',status:3},{name: '已评价',status:10}],
      currNavList: [{name: '全部', status:-1},{name: '待付款',status:0},{name: '待发货',status:1},{name: '待收货',status:2}],
      currIndex:0,
      navShow: 0,
      orderList: [],
      loading: false, // 加载状态
      finished: false, // 是否加载
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      statusType: -1, // 选择状态
      statusNum: 'null', // 提交类型
      is_nav_show: 0, // 1:已收货隐藏 2：待评价隐藏
    }
  },
  created() {

    console.log('zheli')
    var type = this.$route.query.type
    if (type != undefined){
      this.statusNum = type  // 提交类型
      if (type=='null'){
        this.statusType = -1 // 选择状态
      } else {
        // this.currIndex = type
        this.statusType = type // 选择状态
      }
    } else {

    }
    this.getList()
    console.log('type',type)
    console.log('currIndex',this.currIndex)
  },
  methods: {
    goPay(item){
      // console.log(item)
      var data = JSON.stringify(item)
      this.$router.push({path:'/submitOrder',query: {id:item.id,pay:data}})
    },
    clickNav(index){
      this.currIndex = index
      // console.log(this.currIndex)
      this.statusType = this.currNavList[index].status
      var statusNum= this.currNavList[this.currIndex].status
      if (statusNum=='-1'){
        this.statusNum = 'null'
      } else {
        this.statusNum= this.currNavList[this.currIndex].status
      }
      this.currentPage = 1;//页数+1
      this.orderList = []
      this.getList()
    },
    goOrderComment(id){ // 评价

      this.$router.push({path:'/orderComment',query:{id:id}})
    },
    takeSalesReturn(id){
      this.$router.push({path:'/orderSalesReturn',query:{id:id}})
    },
    clickSalesPop(item){
      console.log(item)
      this.refundItem = item.refund
      this.returnShow = true
    },
    takeGoodClick(id){ // 确定收货
      // console.log('zheli ')
      Dialog.confirm({
        title: '提示',
        message: '是否要确定收货？',
      })
        .then(() => {
          // console.log('quedign')
          // on confirm
          takeGood(id).then(res => {
            console.log(res)
            if(res.code == 200)
            {
              this.$toast(res.message)
              const secounds = 2
              let num = 0
              const timer = setInterval(() => {
                if(num < secounds) {
                  num++
                }else {
                  clearInterval(timer)
                  this.statusType = -1
                  this.statusNum = 'null'
                  this.immediate = false
                  this.currentPage = 1
                  this.getList()
                }
              }, 1000)// 这里的时间不要忘记，否则没有效果

            }
            else
            {
              this.$toast(res.message)
              // this.$router.push('/');
            }
          })
        })
        .catch(() => {
          // on cancel
        });

    },
    cancelOrder(id){ // 取消订单
      Dialog.confirm({
        title: '提示',
        message: '是否要取消订单？',
      })
        .then(() => {
          // on confirm
          orderDel(id).then(res => {
            if(res.code == 200)
            {
              this.$toast('取消成功')
              const secounds = 2
              let num = 0
              const timer = setInterval(() => {
                if(num < secounds) {
                  num++
                }else {
                  clearInterval(timer)
                  this.statusType = -1
                  this.statusNum = 'null'
                  this.immediate = false
                  this.currentPage = 1
                  this.getList()
                }
              }, 1000)// 这里的时间不要忘记，否则没有效果

            }
            else
            {
              this.$toast(res.message)
              // this.$router.push('/');
            }
          })
        })
        .catch(() => {
          // on cancel
        });

    },
    getList(){
      var that = this
      // var statusNum= this.currNavList[this.currIndex].status
      // if (statusNum=='-1'){
      //   statusNum = 'null'
      // } else {
      //   statusNum= this.currNavList[this.currIndex].status
      // }
      var data = {
        status: this.statusNum,
        page:1
      }
      getOrderList(data).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data.data)
          that.orderList = res.data.data
          // 加载状态结束
          this.loading = false;
          if (res.data.data.length == res.data.total){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data.length == 0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 不可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var statusNum= this.currNavList[this.currIndex].status
      if (statusNum=='-1'){
        statusNum = 'null'
      } else {
        statusNum= this.currNavList[this.currIndex].status
      }
      var data = {
        status: statusNum,
        page:this.currentPage
      }
      getOrderList(data).then(res => {
        if(res.code == 200)
        {
          // console.log(res.data.total)
          // console.log('res',res.data.data)
          var arr = this.orderList.concat(res.data.data);
          // console.log(arr.length)
          that.orderList = arr
          // 加载状态结束
          this.loading = false;
          if (that.orderList.length == res.data.total) { // 数据全部加载完成
            this.finished = true;
            // this.loading = false;
            console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    goDes(id){
      this.$router.push({path:'/orderDes',query: {id:id}})
    },
    clickNavMore(){
      this.navShow = !this.navShow
      if (this.currNavList.length==5) {
        if (this.currNavList[4].status==3){ //已收货 隐藏

            this.is_nav_show = 1
          // console.log('已收货',this.is_nav_show)
        } else if(this.currNavList[4].status==10){  // 已评价

          this.is_nav_show = 2
          // console.log('已评价',this.is_nav_show)
        } else {
          // console.log('eeee')
          this.is_nav_show = 0
        }
      }
    },
    clickSecNav(item){
      // console.log(item)
      // console.log('this.is_nav_show',this.is_nav_show)
      if (this.currNavList.length==4){
        this.currNavList.push(item)
        if (this.currNavList.length==5) {
          if (this.currNavList[4].status==3){ //已收货 隐藏
            this.is_nav_show = 1
          } else if(this.currNavList[4].status==10){  // 已评价
            this.is_nav_show = 2
          } else {
            this.is_nav_show = 0
          }
        }
      } else {
        this.currNavList.splice(this.currNavList.length-1,1,item);
      }

      this.navShow = false
      this.statusType = this.currNavList[4].status
      var statusNum= this.currNavList[4].status
      if (statusNum=='-1'){
        this.statusNum = 'null'
      } else {
        this.statusNum= this.currNavList[4].status
      }
      this.orderList = []
      this.getList()
    },
    onClickLeft() {
      // this.$router.go(-1);
      this.$router.push({path:'/user'})
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    width: 80%;margin-top: -90px;
    max-height: 80%;overflow-y: auto;
    background-color: #fff;border-radius: 10px;
    .title{
      text-align: center;padding: 20px 20px;position: relative;
      .icon-colse-span{
        position: absolute;right: 20px;top: 20px;font-size: 40px;color: #999999;
      }
    }
    .item-box{
      padding: 20px;
      .item{
        padding: 10px 0;
        .title-lf{
          color: #646566;
        }
        .cause-box{
          width: 75%;
        }
        .cause-box-pic{
          width: 75%;
          img{
            width: 130px;height: 130px;
          }
        }
      }
    }
  }
}


.nav-show-box{
  text-align: right;display: block;
  span{
    display: inline-block;padding: 5px 24px 15px 24px;
  }
  .is-hide{
    display: none;
  }
}
.van-button--warning {
 color: #282828;
}
.van-dialog--round-button .van-dialog__cancel, .van-dialog--round-button .van-dialog__confirm {
  margin-right: 20px;
  border-radius: 60px;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.nav-box{
  padding: 24px;font-size: 26px;color: #333333;
  .nav-box-sec{
    width: 80%;margin-left: 20px;
    .nav-item{
      width: 20%;
    }
    .active{
      font-weight: bold;
      color: #F23926;
      font-size: 32px;
    }
  }

  img{
    width: 19px;height: auto;display: block;
  }
}
.order-list{
  padding: 24px;
  .order-item{
    background: #FFFFFF;
    border-radius: 20px;padding: 20px 25px 20px;
    margin-bottom: 22px;
    .order-top-box{
      font-size: 24px;color: #000000;padding-bottom: 30px;
      .mch-header{
        font-weight: bold;
        color: #000000;font-size: 28px;
        img{
          width: 24px;height: auto;display: inline-block;margin-right: 10px;
        }
      }
    }
    .order-content{
      .goods-item{
        .goods-pic{
          width: 164px;
          height: 164px;
          border-radius: 15px;margin-right: 10px;
        }
        .goods-content{
          width: 500px;
          .goods-name {
            font-weight: bold;
            color: #636363;font-size: 28px;
            margin-bottom: 10px;text-align: left;width: 100%;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            span{
              display: inline-block;
              padding: 0 10px;margin-right: 10px;
              background: #F23926;
              border-radius: 5px;font-size: 18px;color: #FFFFFF;font-weight: bold;text-align: center;
            }
          }
          .tag-box{text-align: left;
            .tag{display: inline-block;margin-right: 10px;border: 1px solid #55BB3A;
              border-radius: 8px;color: #55BB3A;font-size: 20px;padding: 2px 15px;font-weight: 400;}
          }
          .price{
            font-weight: 500;
            color: #282828;font-size: 28px;
          }
          .num{
            color: #A4A4A4;font-weight: 400;font-size: 20px;
          }
        }
      }

    }
    .order-btn-box{
      padding-top: 30px;
      border-top: 1px solid #EBEBEB;margin-top: 20px;
      text-align: right;
      .order-sum{
        text-align: right;
      }
      .sum-goods{
        font-size: 24px;color: #A6A6A6;
      }
      .sum-goods-txt{
        font-weight: bold;
        color: #000000;font-size: 26px;margin: 0 10px;
      }
      .price-num{
        font-weight: 500;
        color: #F23926;font-size: 32px;

      }
      .btn-list{
        margin-top: 30px;
        .btn{
          display: inline-block;
          width: 178px;
          font-weight: bold;padding: 12px 0;
          color: #000000;font-size: 24px;text-align: center;
          background: #FDD80D;
          border-radius: 29px;
        }
        .btn-des{
          background: #FFFFFF;
          border: 2px solid #D8D8D8;margin-right: 20px;
        }
      }
    }
  }
}
.btn-comment{
  background: #FFFFFF;
  border: 2px solid #FDD80D;font-size: 24px;padding: 5px 30px;border-radius: 35px;color: #000000;
}
</style>
